import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getMessagesUnreadCount } from '@/lib/api/messages';
import { usePolledData } from '@/lib/usePolledData';

const POLL_DEPS: readonly unknown[] = [];

// Story 086 — player message center entry point. Lives next to the
// notifications bell on the player surface, with a polled unread badge
// driven by GET /player/messages/unread-count (separate from the bell).
export function MessagesLink() {
  const { t } = useTranslation('player');
  const navigate = useNavigate();
  const { data } = usePolledData<number>(
    () => getMessagesUnreadCount().then((r) => r.count),
    POLL_DEPS,
  );
  const unread = data ?? 0;

  return (
    <Button
      variant="ghost"
      size="icon"
      data-testid="messages-link"
      aria-label={t('messages.aria_label')}
      className="relative h-9 w-9"
      onClick={() => navigate('/player/messages')}
    >
      <MessageSquare className="h-4 w-4" />
      {unread > 0 && (
        <span
          data-testid="messages-unread-badge"
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-medium leading-none text-white"
        >
          {unread}
        </span>
      )}
    </Button>
  );
}
